export { default } from "./debounce.mjs";
export * from "./debounce.mjs";